import { useEffect, useState } from "react";
import { useAppSelector } from "../store/hooks";
import { obterIdTenent } from "../services/seguranca";
import api from "../services/api";

// Chave fixa da categoria de sistema da caução (Categoria.ChaveCaucao no backend). O locador pode
// renomear essa categoria (ex.: "ADESÃO") e o nome passa a valer para os lançamentos, as cobranças
// e os rótulos da tela. O sistema acha a caução pela chave, nunca pelo nome.
export const CHAVE_CATEGORIA_CAUCAO = 'CAUCAO';
const NOME_PADRAO = 'CAUÇÃO';

// Um pedido por empresa enquanto a página estiver aberta; quem renomeia a categoria chama
// invalidarNomeCaucao() para as próximas telas lerem o nome novo.
const cache = new Map<string, Promise<string>>();

export function invalidarNomeCaucao() {
    cache.clear();
}

function buscarNome(idEmpresa: string): Promise<string> {
    if (!cache.has(idEmpresa)) {
        cache.set(idEmpresa, api.get(`/CategoriaPorEmpresa/${idEmpresa}`)
            .then(r => {
                const categoria = (r.data ?? []).find((c: any) => c.chave === CHAVE_CATEGORIA_CAUCAO);
                return (categoria?.nome || NOME_PADRAO).trim().toUpperCase();
            })
            .catch(() => {
                cache.delete(idEmpresa);
                return NOME_PADRAO;
            }));
    }
    return cache.get(idEmpresa)!;
}

// "ADESÃO" -> "Adesão"; "DEPÓSITO DE GARANTIA" -> "Depósito de garantia"
function capitalizar(nome: string) {
    const minusculo = nome.toLocaleLowerCase('pt-BR');
    return minusculo.charAt(0).toLocaleUpperCase('pt-BR') + minusculo.slice(1);
}

export interface NomeCaucao {
    /** Como aparece nos lançamentos e cobranças: "ADESÃO". */
    maiusculo: string;
    /** Para início de rótulo: "Adesão". */
    titulo: string;
    /** Para o meio da frase: "adesão". */
    minusculo: string;
}

function montar(nome: string): NomeCaucao {
    return { maiusculo: nome, titulo: capitalizar(nome), minusculo: nome.toLocaleLowerCase('pt-BR') };
}

export function useNomeCaucao(): NomeCaucao {
    const token = useAppSelector(state => state.token);
    const [nome, setNome] = useState<string>(NOME_PADRAO);

    useEffect(() => {
        const idEmpresa = token ? obterIdTenent(token) : null;
        if (!idEmpresa) return;
        let vivo = true;
        buscarNome(idEmpresa).then(n => { if (vivo) setNome(n); });
        return () => { vivo = false; };
    }, [token]);

    return montar(nome);
}
